import request from '@/utils/request'

/**
 * 分页查询操作日志
 * @param params 查询条件
 */
export function getOperationLogList(params) {
  return request({
    url: '/operationLog.listOperationLog',
    method: 'post',
    data: params
  })
}